import { IconTrain16, ArticleParagraph1, UIText2 } from '@cian/ui-kit';

import * as styles from './Railways.css';

export interface IProps {
  name: string;
  time: string;
}

export function Railways({ name, time }: IProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['icon']}>
        <IconTrain16 display="block" />
      </div>
      <span className={styles['name']}>
        <ArticleParagraph1 display="inline">{name}</ArticleParagraph1>
      </span>
      {time && <UIText2>{`・`}</UIText2>}
      {time && <UIText2 color="text-secondary-default">{time}</UIText2>}
    </div>
  );
}
